import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
  readonly?: boolean
}

export const DateField = observer(({ dataSchemaItem, field, readonly = false }: Props) => {
  return (
    <DayPicker
      mandatory={dataSchemaItem.required}
      label={dataSchemaItem.label}
      mode="single"
      value={field.value}
      onChange={(newValue) => field.set(newValue)}
      withNull
      withNullLabel={i18n.t('common.clear_selection')}
      readonly={readonly}
    />
  )
})
